module.exports = __webpack_public_path__ + "media/icons/select_all@3x-3d13c783.svg";